import gql from 'graphql-tag';
export default {
  
  data() {
    return {
      parNumsList:[],
      isTakePhone: false,
      video: null,
      canvas: null,
      // 相机列表
      CameraList: [],
      // 选择的相机
      selectCamera: '',
      // 拍摄的摄像头像素
      videoWidth: 0,
      videoHeight: 0,
      tracks: [],
      isProcessing: false,
      picType: '',
      takePhotoLoading: false,
      isShowVideoFlash: false,
    };
  },
  
  methods: {
    async takeAPhone(type) {
      if (type) {
        this.picType = type;
      }
      await this.getCameraList();
      await this.showCamera();
      this.isTakePhone = true;
      this.$nextTick(() => {
        this.$refs.cameraCon.focus();
      });
    },
    // 获取摄像头列表
    async getCameraList() {
      if (navigator.mediaDevices || navigator.mediaDevices.enumerateDevices) {
        const enumeratorPromise = await navigator.mediaDevices.enumerateDevices();
        const deviceArr = enumeratorPromise.filter(item => item.kind === 'videoinput');
        if (deviceArr.length > 0) {
          let count = 1;
          this.CameraList = deviceArr.map(item => {
            return {
              value: item.deviceId,
              label: item.label || `Camera ${count++}`,
            }
          });
          // 选中上次拍摄的设备，如果没有记忆上次拍摄的设备就默认选中第一个
          if (window.localStorage.getItem('selectCamera')) {
            const cameraId = window.localStorage.getItem('selectCamera');
            const filterDevice = deviceArr.filter(item => item.deviceId === cameraId);
            if (filterDevice.length > 0) {
              this.selectCamera = cameraId;
            } else {
              this.selectCamera = deviceArr[0].deviceId;
            }
          } else {
            this.selectCamera = deviceArr[0].deviceId;
          }
        } else {
          this.CameraList = [];
          this.selectCamera = '';
        }
      }
    },
    // 显示拍摄影像
    async showCamera() {
      try {
        if (this.selectCamera) {
          const videoConstraints = {};
          videoConstraints.deviceId = {exact: this.selectCamera};
          const constraints = {
            video: videoConstraints,
            audio: false
          };
          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              try {
                this.video.srcObject = stream;
              } catch (e) {
                this.video.src = window.URL.createObjectURL(stream);
              }
              self.video.play();
              this.tracks = stream.getTracks();
            })
            .catch(error => {
              this.$message({
                message: '请尝试取消其他程序设备占用或重新连接设备',
                type: 'error',
                duration: 4000,
              });
            });
        } else {
          // this.video.load();
        }
      } catch (error) {
        this.$message({
          message: '请尝试取消其他程序设备占用或重新连接设备',
          type: 'error',
          duration: 4000,
        });
      }
    },
    // 准备调用拍照
    async takePicture() {
      if (!this.isProcessing) { // 防止连续触发
        this.isProcessing = true;
        if (this.picType === 'dt') {
          await this.takePhotos(Util.GENERAL.code);
          this.isProcessing = false;
        } else if (this.picType === 'sk') {
          await this.takePhotos(Number(this.selectSkinType));
          this.isProcessing = false;
          window.localStorage.setItem('skinType', this.selectSkinType);
        } else if (this.picType === 'hairdressing') {
          await this.takePhotos('hairdressing');
          this.isProcessing = false;
        }
      }
    },
    // 拍照
    async takePhotos(type) {
      if (type === 'hairdressing') {
        if (this.commonData.patientId === -1) {
          this.$message.error("请先添加患者信息！");
          return;
        }
        if (this.commonData.relevantInfoId === -1) {
          this.$message.error("请先添加相关信息！");
          return;
        }
      } else {
        if (this.diagnosisId === -1) {
          this.$message.error("请先添加检查部位！");
          return;
        }
      }
  
      let ctx = this.canvas.getContext("2d");
      ctx.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
      // canvas图像转为图片
      let image = new Image();
      image.src = this.canvas.toDataURL("image/png",0.98);
      let base64ImgData = image.src.replace(
        /^data:image\/(jpeg|png|gif);base64,/,
        ""
      );
      let imgObjArr = [];
      let imgJson = {};
      if (type !== 'hairdressing') { // 判断是不是美容
        imgJson.type = type;
      }
      imgJson.base64 = base64ImgData;
      imgJson.ext = "jpg";
      imgJson.status = this.commonData.imageStatus === "无" ? "" : this.commonData.imageStatus;
      imgJson.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
      imgObjArr.push(imgJson);
   
      
      this.isProcessing = false;
      this.videoFlashPlay();
      await this.uploadImages(imgObjArr, type);
      if (this.selectCamera) {
        window.localStorage.setItem('selectCamera', this.selectCamera);
      }
    },
    // 上传图片
    async uploadImages(imgObjArr, type) {
      if (type === 'hairdressing') {
        // 显示正在上传缩略图
        this.$refs.CommonUploadImages.showThumbnailImage(imgObjArr);
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $treat_no: String!
              $images: [cosmetologyImageInput!]!
              $last_img_time: String
              $agent_name: String
            ){
              addCosmetologyImages(
                patient_id: $patient_id
                treat_no: $treat_no
                images: $images
                last_img_time: $last_img_time
                agent_name: $agent_name
              )
            }`,
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
              images: imgObjArr/*,
              last_img_time: syncLastTime,
              agent_name: agentName*/
            },
          });
          this.$message({
            message: "上传图片成功",
            type: "success"
          });
        } catch (error) {
          this.$message.error('上传失败');
        }
      }
    },
    // 按键拍照
    keydownTakePicture(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.keyCode === 123 || e.keyCode === 32) {
        this.takePicture();
      }
    },
    // 选择了拍摄设备
    cameraChange() {
      this.showCamera();
    },
    closeCamera() {
      this.isTakePhone = false;
      try {
        if (this.tracks[0]) {
          this.tracks[0].stop();
        }
      } catch (error) {
        console.log(error);
      }
    },
    videoFlashPlay() {
      this.isShowVideoFlash = true;
      setTimeout(() => {
        this.isShowVideoFlash = false;
      }, 400);
    },
    // videoCanPlay(e) {
    //   this.videoWidth = e.target.videoWidth*2;
    //   this.videoHeight = e.target.videoHeight*2;
    // },
  },
}
